/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RepatriationOpportunityCreationResponse
 */
export interface RepatriationOpportunityCreationResponse {
    /**
     * 
     * @type {string}
     * @memberof RepatriationOpportunityCreationResponse
     */
    repatriationOpportunityGroupId: string;
}

/**
 * Check if a given object implements the RepatriationOpportunityCreationResponse interface.
 */
export function instanceOfRepatriationOpportunityCreationResponse(value: object): value is RepatriationOpportunityCreationResponse {
    if (!('repatriationOpportunityGroupId' in value) || value['repatriationOpportunityGroupId'] === undefined) return false;
    return true;
}

export function RepatriationOpportunityCreationResponseFromJSON(json: any): RepatriationOpportunityCreationResponse {
    return RepatriationOpportunityCreationResponseFromJSONTyped(json, false);
}

export function RepatriationOpportunityCreationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepatriationOpportunityCreationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'repatriationOpportunityGroupId': json['repatriationOpportunityGroupId'],
    };
}

export function RepatriationOpportunityCreationResponseToJSON(value?: RepatriationOpportunityCreationResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'repatriationOpportunityGroupId': value['repatriationOpportunityGroupId'],
    };
}

